import * as React from 'react';
import { SVGProps, memo } from 'react';

function ChevronRightIcon(props?: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={14} height={25} fill="none" {...props}>
      <g clipPath="url(#a)">
        <path
          stroke={props?.stroke ? props.stroke : '#E60000'}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M1.333 1.167 12.668 12.5 1.334 23.833"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M.333 24.5V.5h13.333v24z" />
        </clipPath>
      </defs>
    </svg>
  );
}
export default memo(ChevronRightIcon);

export function ChevronRightSmIcon(props?: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={10} height={18} fill="none" {...props}>
      <g clipPath="url(#a)">
        <path stroke="#E60000" strokeLinecap="round" strokeLinejoin="round" d="M.75.5 9.25 9l-8.5 8.5" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 18V0h10v18z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function ChevronRightIconCalendar(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
      <path d="M7.75 3.5L16.25 12L7.75 20.5" stroke={props?.stroke ? props.stroke : '#E60000'} strokeLinecap="round" />
    </svg>
  );
}

export function ChevronRightIcon2x(props?: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} fill="none" {...props}>
      <path d="M12.9167 5.83333L27.0834 20L12.9167 34.1667" stroke="#E60000" strokeLinecap="round" />
    </svg>
  );
}
